import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watchEffect } from "vue";
import { useStore } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
let cutDarkValue = ref(store.state.cutDarkValue)

watchEffect(()=>{
  cutDarkValue.value = store.state.cutDarkValue
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["showDarkModel", {'blackModel':_unref(cutDarkValue) === 0}]),
    style: {"height":"100%"}
  }, [
    _createVNode(_component_router_view)
  ], 2))
}
}

})